module.exports = __webpack_public_path__ + "img/no-tasks.4887226e.png";